import { useEffect, useRef } from "react";

import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";
import { LOTTIE_ASSETS } from "@swiggy-private/core-ui";
import type { IToingPriceComparisonBEData } from "@swiggy-private/cart-types";

const toingPriceComparisonPrefetchFileIds = [
    LOTTIE_ASSETS.WINNING_STATE_LOTTIE_FILE_ID,
    LOTTIE_ASSETS.LOST_DARE_STATE_LOTTIE_FILE_ID,
    LOTTIE_ASSETS.TUTORIAL_STATE_LOTTIE_FILE_ID,
    LOTTIE_ASSETS.TIE_WITH_SAVINGS_LOTTIE_FILE_ID,
    LOTTIE_ASSETS.TIE_WITHOUT_SAVINGS_LOTTIE_FILE_ID,
    LOTTIE_ASSETS.SCANNING_STATE_LOTTIE_FILE_ID,
];

export const usePrefetchToingPriceComparisonLotties = (
    priceComparisonData: IToingPriceComparisonBEData | undefined | null,
) => {
    const prefetchedRef = useRef<Set<string>>(new Set());

    useEffect(() => {
        if (isEmpty(priceComparisonData)) {
            return;
        }

        toingPriceComparisonPrefetchFileIds.forEach((fileId) => {
            if (prefetchedRef.current.has(fileId)) return;
            prefetchedRef.current.add(fileId);
            const url = getCloudinaryUrl(fileId) || "";
            if (!url) {
                prefetchedRef.current.delete(fileId);
                return;
            }
            fetch(url).catch(() => {
                prefetchedRef.current.delete(fileId);
            });
        });
    }, [priceComparisonData]);
};
